import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import {
  DASHBOARD_API_URL,
  GET_NUMBER_OVERVIEW_QUERY_KEY,
  GET_STATUS_OVERVIEW_QUERY_KEY,
  GET_WEEKLY_EXPORTS_QUERY_KEY
} from '@/constants';
import { apiUrl } from '@/helpers';

export const dashboardEndpoints = {
  getNumberOverview: () => axios.get(`${apiUrl()}${DASHBOARD_API_URL}/number-overview`),
  getWeeklyExports: () => axios.get(`${apiUrl()}${DASHBOARD_API_URL}/weekly-exports`),
  getStatusOverview: () => axios.get(`${apiUrl()}${DASHBOARD_API_URL}/status-overview`)
};

export const useGetNumberOverviewQuery = (currentUserId: number) => {
  return useQuery([GET_NUMBER_OVERVIEW_QUERY_KEY, { currentUserId }], () =>
    dashboardEndpoints.getNumberOverview().then((res) => res.data)
  );
};

export const useGetWeeklyExportsQuery = (currentUserId: number) => {
  return useQuery([GET_WEEKLY_EXPORTS_QUERY_KEY, { currentUserId }], () =>
    dashboardEndpoints.getWeeklyExports().then((res) => res.data)
  );
};

export const useGetStatusOverviewQuery = (currentUserId: number) => {
  return useQuery([GET_STATUS_OVERVIEW_QUERY_KEY, { currentUserId }], () =>
    dashboardEndpoints.getStatusOverview().then((res) => res.data)
  );
};
